import { useAtom } from "jotai";
import { useEffect } from "react";
import { ppmAtom } from "~/utils/jotai";

interface FlytHeaderState {
	antallSider?: number;
	loFavor?: boolean;
	navigationBarTitle?: string;
}

export const flytHeaderAtom = ppmAtom<FlytHeaderState>("flytHeader", {});

function useFlytHeader(state?: FlytHeaderState) {
	const [flytState, setState] = useAtom(flytHeaderAtom);

	useEffect(() => {
		if (state) {
			setState(state);
		}
	}, [state?.antallSider, state?.loFavor, state?.navigationBarTitle]);

	return flytState;
}
export default useFlytHeader;
